<h2>upp-dialog</h2>
<p class="demo-description">
    Centered modal shell with <code>upp-dialog-header</code> / <code>upp-dialog-content</code> /
    <code>upp-dialog-footer</code> slots. The host reparents to <code>document.body</code> so the overlay covers the full viewport.
</p>

<div class="demo-controls">
    <ion-button size="small" (click)="OnOpen()">Open dialog</ion-button>
    <ion-button size="small" fill="outline" (click)="OnToggleBackdrop()">
        backdropDismiss: {{ backdropDismiss }}
    </ion-button>
</div>

<upp-dialog *ngIf="open" [backdropDismiss]="backdropDismiss" (OnClose)="OnClose()">
    <upp-dialog-header class="demo-dialog-header">
        <h3>Confirm action</h3>
        <ion-button fill="clear" size="small" (click)="OnClose()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
    </upp-dialog-header>

    <upp-dialog-content class="demo-dialog-body">
        <p>Click the backdrop, press Escape, or use Close / Confirm below.</p>
        <p *ngFor="let line of scrollLines">{{ line }}</p>
    </upp-dialog-content>

    <upp-dialog-footer class="demo-dialog-footer">
        <ion-button expand="block" fill="outline" (click)="OnClose()">Close</ion-button>
        <ion-button expand="block" color="warning" (click)="OnClose()">Confirm</ion-button>
    </upp-dialog-footer>
</upp-dialog>
